import { useEffect, useState } from "react";
import { PageHeader, Section } from "@/components/layout/Section";
import { Users, Music, Baby, Heart, Shield, Globe, BookOpen, Sparkles } from "lucide-react";
import api from "@/lib/api";
import { motion } from "framer-motion";

const iconLib = { Users, Music, Baby, Heart, Shield, Globe, BookOpen, Sparkles };

export default function Ministries() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/ministries").then((r) => setItems(r.data));
  }, []);

  return (
    <div data-testid="ministries-page">
      <PageHeader
        kicker="Ministries"
        title="Find your place. Serve with purpose."
        subtitle="Every member is a minister. Discover a family within the family where your gifts flourish."
      />
      <Section>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {items.map((m, i) => {
            const Icon = iconLib[m.icon] || Users;
            return (
              <motion.div
                key={m.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                className="card-soft p-8"
                data-testid={`ministry-card-${i}`}
              >
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-royal to-royal-800 text-gold flex items-center justify-center shadow-md">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="mt-6 text-xs uppercase tracking-widest text-gold-500">{m.tagline}</div>
                <h3 className="mt-2 font-serif text-2xl text-royal">{m.name}</h3>
                <p className="mt-3 text-slate-600 leading-relaxed">{m.description}</p>
                {m.leader && (
                  <div className="mt-5 text-xs text-slate-500">
                    Led by <span className="text-royal font-semibold">{m.leader}</span>
                  </div>
                )}
              </motion.div>
            );
          })}
        </div>
      </Section>
    </div>
  );
}
